"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _toConsumableArray2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _menusTwo = _interopRequireDefault(require("@/components/menusTwo.vue"));
var _characteristiNav = _interopRequireDefault(require("@/components/characteristiNav.vue"));
var _courseZT = _interopRequireDefault(require("@/components/courseZT.vue"));
require("../index.less");
var _courseCard = _interopRequireDefault(require("@/components/courseCard/courseCard.vue"));
var _index2 = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseCard: _courseCard.default,
    Banner: _banner.default,
    Search: _search.default,
    Nav: _characteristiNav.default,
    Menus: _menusTwo.default,
    CourseItem: _courseZT.default
  },
  data: function data() {
    return {
      menusList: [{
        tit: '专业大类',
        itemList: [{
          name: '全部'
        }, {
          name: '农林牧渔'
        }, {
          name: '装备制造'
        }, {
          name: '电子与信息'
        }, {
          name: '资源环境与安全'
        }, {
          name: '能源动力与材料'
        }, {
          name: '生物与化工'
        }, {
          name: '交通运输'
        }, {
          name: '财经商贸'
        }, {
          name: '土木建筑'
        }, {
          name: '水利'
        }, {
          name: '轻工纺织'
        }, {
          name: '食品药品与粮食'
        }, {
          name: '医药卫生'
        }, {
          name: '旅游'
        }, {
          name: '文化艺术'
        }, {
          name: '新闻传播'
        }, {
          name: '教育与体育'
        }, {
          name: '公安与司法'
        }, {
          name: '公共管理与服务'
        }, {
          name: '公共基础与通识教育'
        }],
        actheight: false,
        act: 0,
        isZhan: true
      }, {
        tit: '行业门类',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wIndustryCategory)),
        actheight: false,
        act: 0,
        isZhan: true
      }, {
        tit: '岗位筛选',
        itemList: [],
        actheight: false,
        act: 0,
        isZhan: false
      }],
      query: {
        pageNum: 1,
        pageSize: 20,
        searchValue: '',
        specialClass: '',
        post: '',
        majorTypeName: '',
        industryDetailName: ''
      },
      list: [],
      total: 0,
      loading: false
    };
  },
  methods: {
    specialClass: function specialClass(e) {
      if (e) {
        this.query.specialClass = e[1].id;
        this.getList();
      }
    },
    getJob: function getJob(val) {
      //岗位筛选
      this.query.post = val;
      this.query.pageNum = 1;
      this.getList();
    },
    toSsearch: function toSsearch(e) {
      this.query.searchValue = e.courseName;
      if (e.majorName == "全部") {
        this.query.majorTypeName == '';
      } else {
        this.query.majorTypeName = e.majorName;
      }
      this.getList();
    },
    chooseList: function chooseList(e) {
      console.log(e);
      if (e[0] == '专业大类') {
        if (e[1].name == '全部') {
          this.query.majorTypeName = '';
        } else {
          this.query.majorTypeName = e[1].name;
        }
      } else if (e[0] == '行业门类') {
        if (e[1].name == '全部') {
          this.query.industryDetailName = '';
        } else {
          this.query.industryDetailName = e[1].remark;
        }
      }
      this.query.pageNum = 1;
      this.getList();
    },
    // 获取课程
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.next = 1;
              return (0, _index2.coursesList)(this.query);
            case 1:
              res = _context.sent;
              if (res.code == 200) {
                this.list = res.rows;
                this.total = res.total;
                this.loading = false;
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.query.pageSize = e;
      this.query.pageNum = 1;
      this.getList();
    }
  },
  created: function created() {
    // this.getList();
    // this.getList();
  }
};